import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface RoleDetailsContentParams {
    roleName: string;
    assignedUsers: string | number;
    description?: string;
}

export default function RoleDetailsContent({
    roleName,
    assignedUsers,
    description,
}: RoleDetailsContentParams) {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col gap-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex flex-col border border-gray-200 rounded-xl p-2">
                    <Text type="secondary" className="text-sm">
                        {t('pages.role.details.roleName')}
                    </Text>
                    <Text className="text-[16px] text-blue-600 font-medium">
                        {roleName ?? 'Account Manager'}
                    </Text>
                </div>

                <div className="flex flex-col border border-gray-200 rounded-xl p-2">
                    <Text type="secondary" className="text-sm">
                        {t('pages.role.details.users')}
                    </Text>
                    <Text className="text-[16px] text-blue-600 font-medium">
                        {assignedUsers ?? 0}
                    </Text>
                </div>
            </div>

            <div className="flex flex-col border border-gray-200 rounded-xl p-2">
                <Text type="secondary" className="text-sm">
                    {t('pages.role.details.description')}
                </Text>
                <Text className="text-[16px] text-blue-600 font-medium">
                    {description ? description : <span>No Description</span>}
                </Text>
            </div>
        </div>
    );
}
